import apiResource from '@/services/http/api/resource';

const defaultState = () => {
    return {
        loader: null
    };
};

export default {
    namespaced: true,
    state: defaultState(),
    getters: {
        getLoader: state => state.loader
    },
    mutations: {
        setLoader (state, payload) {
            state.loader = payload;
        }
    },
    actions: {
        getLangs (context) {
            context.commit('setLoader', true);
            apiResource.getLangs().then(({ data }) => {
                window.LANGS = process.env.VUE_APP_HIDE_CUSTOM_LANGS === 'true' ? null : data;
            }).finally(() => {
                context.commit('setLoader', false);
            });
        }
    }
};
